import React, {  useState } from "react";
import { postCirugiaCirujanoACargoEspecialidad } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import TablaListaDeSeleccionMedicosProcedimientoDQ from "./TablaListaDeSeleccionMedicosProcedimientoDQ";

const ModalListaDeSeleccionMedicosProcedimientoDQ = ({setmodalOnSeleccionMedicoEspecialista,passDataMedico}) => {
  const [dataMedico, setDataMedico] = useState([]);
  const [loading, setLoading] = useState(true);

  const passInfoMedico=(data)=>{
    passDataMedico(data)
    setmodalOnSeleccionMedicoEspecialista(false);
  }

  const handleCancelarClick = () => {
    setmodalOnSeleccionMedicoEspecialista(false);
  };

  const handleBuscar = (e) => {
    e.preventDefault();
    setLoading(false);
    let cedulaM = e.target.cedula.value;
    let nombreM = e.target.nombre.value;
    let codigoMedico = e.target.codigoMedico.value;
    let medicoEspecialidad = e.target.especialidadMedico.value;
    const body = {
      varMMEstado: "A",
      varEspEst: "S",
      varMEEstE: "S",
      varMMCedM: cedulaM,
      varMMNomM: nombreM,
      varMMCODM: codigoMedico,
      varMENomE: medicoEspecialidad,
    };
    postCirugiaCirujanoACargoEspecialidad(body).then((res) => {
      
      setTimeout(() => {          
        setLoading(true);
      }, 3000);
      setDataMedico(res.data);
    });
  };
  

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md  bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Lista de Selección de Médicos
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <form onSubmit={handleBuscar}>
              <div className="flex py-2 text-left">
                <div className="w-1/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Cédula Médico
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Codigo Médico
                  </label>
                  
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      name="codigoMedico"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                    <div className="w-1/3">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Nombre</label>
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      name="nombre"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                
              </div>
              <div className="flex py-2 text-left">
                <div className="w-2/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Especialidad
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      name="especialidadMedico"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <button
                      type="submit"
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full sm:px-1 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Código
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Nombre
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Cédula Medico
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Descripción Especialidad
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Código Especialidad
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {loading?
                            dataMedico.map((item,index)=>(
                                <TablaListaDeSeleccionMedicosProcedimientoDQ key={index} item={item} passInfoMedico={passInfoMedico}/>
                            ))
                            :
                            <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                              <Loading />
                            </td>
                          </tr>
                        }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalListaDeSeleccionMedicosProcedimientoDQ;
